import { api } from './authService';

export const segmentTemplatesService = {
  async list() {
    const res = await api.get('/api/v2/segments/templates');
    return Array.isArray(res.data) ? res.data : [];
  },
  async create({ name, description, criteria, sort_order }) {
    const res = await api.post('/api/v2/segments/templates', { name, description, criteria, sort_order });
    return res.data;
  },
  async remove(id) {
    await api.delete(`/api/v2/segments/templates/${id}`);
  },
};

/** FastCube admins manage templates (mirrors backend `is_fastcube_admin`). */
export function canManageTemplates(user) {
  return Boolean(user?.is_admin && user?.is_fastcube);
}
